if (!window.customElements.get('blog-listing')) {
  class BlogListing extends HTMLElement {
    constructor() {
      super();
      this.articlesContainer = document.querySelector('#blog-articles') || document.querySelector('.blog-articles');
      this.loadMoreButton = this.querySelector('.js-load-more');
      this.totalPagesInput = this.querySelector('[data-all-pages]');
      this.currentPageInput = this.querySelector('[data-this-page]');
      this.nextLinkInput = this.querySelector('[data-next-link]');
      this.currentCountEl = this.querySelector('[data-current-count]') || null;
      this.currentNumbersEl = this.querySelector('[data-current-numbers]') || null;

      this.handleLoadMoreClick = this.handleLoadMoreClick.bind(this);
    }

    connectedCallback() {
      if (this.loadMoreButton) {
        this.loadMoreButton.addEventListener('click', this.handleLoadMoreClick);
      }
    }

    disconnectedCallback() {
      if (this.loadMoreButton) {
        this.loadMoreButton.removeEventListener('click', this.handleLoadMoreClick);
      }
    }

    get totalPages() {
      const value = this.totalPagesInput?.value ?? '0';
      return parseInt(value, 10) || 0;
    }

    get currentPage() {
      const value = this.currentPageInput?.value ?? '1';
      return parseInt(value, 10) || 1;
    }

    get nextUrl() {
      return this.nextLinkInput?.value || '';
    }

    setLoading(isLoading) {
      const button = this.loadMoreButton;
      if (!button) return;
      const textSpan = button.querySelector('[load-more-text]');
      const loaderSpan = button.querySelector('[loader]');
      if (isLoading) {
        button.setAttribute('disabled', 'true');
        if (textSpan) textSpan.classList.add('hidden');
        if (loaderSpan) loaderSpan.classList.remove('hidden');
      } else {
        button.removeAttribute('disabled');
        if (textSpan) textSpan.classList.remove('hidden');
        if (loaderSpan) loaderSpan.classList.add('hidden');
      }
    }

    updateCounts() {
      if (!this.articlesContainer) return;
      const articleCount = this.articlesContainer.childElementCount;
      if (this.currentCountEl) {
        this.currentCountEl.setAttribute('data-current-count', String(articleCount));
        this.currentCountEl.textContent = String(articleCount);
      }
      if (this.currentNumbersEl) {
        this.currentNumbersEl.textContent = String(articleCount);
      }
    }

    handleLoadMoreClick() {
      if (!this.nextUrl) {
        this.finish();
        return;
      }

      this.setLoading(true);

      fetch(this.nextUrl, { method: 'GET' })
        .then((response) => response.text())
        .then((responseHTML) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(responseHTML, 'text/html');

          const newItemsContainer = doc.querySelector('#blog-articles') || doc.querySelector('.blog-articles');
          if (newItemsContainer && this.articlesContainer) {
            this.articlesContainer.insertAdjacentHTML('beforeend', newItemsContainer.innerHTML);
          }

          const nextFromDoc = doc.querySelector('[data-next-link]')?.value || '';
          const pageFromDoc = parseInt(doc.querySelector('[data-this-page]')?.value || '0', 10) || this.currentPage + 1;

          if (this.nextLinkInput) this.nextLinkInput.value = nextFromDoc;
          if (this.currentPageInput) this.currentPageInput.value = String(pageFromDoc);

          this.updateCounts();

          const isLastPage = pageFromDoc >= this.totalPages || !nextFromDoc;
          if (isLastPage) {
            this.finish();
          } else {
            this.setLoading(false);
          }
        })
        .catch(() => {
          this.setLoading(false);
        });
    }

    finish() {
      const button = this.loadMoreButton;
      if (!button) return;
      const textSpan = button.querySelector('[load-more-text]');
      const loaderSpan = button.querySelector('[loader]');
      if (textSpan) textSpan.textContent = 'Articles Finished';
      if (loaderSpan) loaderSpan.classList.add('hidden');
      button.classList.add('hidden');
    }
  }

  window.customElements.define('blog-listing', BlogListing);
}
